import axios from 'axios'

class DocumentValidationService {
    /**
     * @description Servicio para validar documentos
     * @param {String} apiUrl - URL base de la API
     */
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    /**
     * @description Validar si el documento contiene firmas
     * @param {String} token
     * @param {FormData} data - FormData con el archivo a validar
     * @returns {Promise<import('../types/api.types').ApiResponse<{filename: string, hasSignatures: boolean}>>}
     * @memberof DocumentValidationService
     */
    async hasSignatures(token, data) {
        let response = await axios.post(`${this.apiUrl}/has-signatures`, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })

        return response.data
    }

}
export { DocumentValidationService as default }
